import { useEffect, useState } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getUserInfo } from 'service/AuthService'
import { setUserAvatar } from 'store/slices/UserSlice'
import userInfo from './userInfo'
const DynamicAvatar = ({ getDynamic }) => {
  const user = userInfo()
 
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const getUserDynamicInfo = async () => {
    // Не делаем запрос, если userId не определен
    if (!user?.userId) {
      console.warn('userId не определен, пропускаем запрос getUserInfo')
      return
    }
    
    try {
      let response = await getUserInfo(user.userId)

      dispatch(
        setUserAvatar({
          userAvatar: response.data,
        }),
      )
    } catch (error) {
      console.log("onoxo")
      if (error.response?.data?.code === 'token_not_valid') {
        const socket = new WebSocket('wss://inn.onoxo.ru/ws/online_status/')

        socket.onopen = () => {
          socket.send(
            JSON.stringify({ command: 'disconnect', user_id: user.userId }),
          )
          socket.close()
        }
        localStorage.removeItem('token')
        localStorage.removeItem('task')
        localStorage.removeItem('user')
       
        localStorage.removeItem('background')
        localStorage.removeItem('subscription')
        navigate('/')
      }
    }
  }
  useEffect(() => {
    getUserDynamicInfo()
  }, [])

  const dynamicUserInfo = useSelector((state) => state.user)
  useEffect(() => {
    getDynamic(dynamicUserInfo.userAvatar)
  })

  return <></>
}

export default DynamicAvatar
